import React, { useEffect } from 'react';
import { Form, Button, Space } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import type { KrybotAgent } from '../../../types/krybot';
import { JsonSchemaEditor } from './JsonSchemaEditor';
import styles from './AgentManagement.module.css';

interface AgentContextTabProps {
  agent: KrybotAgent | null;
  agentData: Partial<KrybotAgent>;
  isCreating: boolean;
  onDataChange: (updates: Partial<KrybotAgent>) => void;
  onSave: () => void;
  loading: boolean;
}

export const AgentContextTab: React.FC<AgentContextTabProps> = ({
  agent,
  agentData,
  isCreating,
  onDataChange,
  onSave,
  loading,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      default_context: agentData.default_context || {},
    });
  }, [agentData.default_context, form]);

  const handleChange = (value: Record<string, unknown> | null) => {
    onDataChange({ default_context: value || {} });
  };

  const validateJson = (_: unknown, value: Record<string, unknown> | null) => {
    if (!value) {
      return Promise.resolve();
    }
    return Promise.resolve();
  };

  return (
    <div className="agent-context-tab">
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>Default Context</h3>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          onClick={onSave}
          loading={loading}
        >
          Save Changes
        </Button>
      </div>
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          default_context: agentData.default_context || {},
        }}
      >
        <Form.Item
          name="default_context"
          rules={[{ validator: validateJson }]}
          help="Default context information that will be provided to the agent for all operations."
        >
          <JsonSchemaEditor
            fieldType="default_context"
            agentType={agentData.agent_type}
            disabled={loading}
            value={agentData.default_context}
            onChange={handleChange}
          />
        </Form.Item>
      </Form>
    </div>
  );
};

